<template>
  <div :class="'ol-amount' + (hasError ? '_error' : '')">
    <span class="ol-amount__sub" @click="sub">-</span>
    <input
      class="ol-amount__input"
      type="text"
      :id="id"
      :name="name"
      v-model="localAmount"
    >
    <span class="ol-amount__plus" @click="add">+</span>
  </div>
</template>

<script>
	export default {
		name: "InputAmount",
		props: {
			value: {
				type: Number|String,
        default: 0
      },
      id: {
				type: String,
        default: ''
      },
      name:{
	      type: String,
	      default: ''
      },
      isRequired: {
				type: Boolean,
        default: false
      }
    },
		data() {
			return {
				localAmount: 0,
        hasError: false
			}
		},
		methods: {
			updateAmount() {
				this.localAmount = Number(this.value);
			},

			add() {
				this.localAmount++;
			},
			sub() {
				this.localAmount--;
			},

			update() {
				this.$emit('input', this.localAmount);
				this.$emit('error', this.hasError);
			}
		},
		watch: {
			value() {
				this.updateAmount();
			},
			localAmount() {
				if (Number(this.localAmount) <= 0 || this.localAmount === '') {
					this.localAmount = 0;

					if (this.isRequired) {
						this.hasError = true;
					}
				} else {
          this.hasError = false;
        }
				this.update();
			}
		},
		mounted() {
			this.updateAmount();
		}

	}
</script>

<style scoped lang="scss">
  $multipleLighten: 10%;
  $backgroundRed: rgba(255, 0, 0, 0.24);
  $colorRed: #f00;

  @mixin block () {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 50px;
    height: 16px;
    padding: 6px 24px;
    border: 1px solid #CBCBCB;
    background: #fff;
    border-radius: 2px;
  }

  @mixin error() {
    color: $colorRed;
    background-color: $backgroundRed;
    border-color: $colorRed;

    &:hover{
      background: lighten($backgroundRed, $multipleLighten);
      color: lighten($colorRed, $multipleLighten);
    }
  }


  .ol-amount {
    @include block;

    &__input {
      padding: 5px 0px;
      width: 38px;
      background: #fff;
      border: none;
      text-align: center;
    }

    &__sub,
    &__plus {
      padding: 7px 12px;
      border: none;
      -moz-user-select: none;
      -o-user-select:none;
      -khtml-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      user-select: none;
      cursor: pointer;

      &:hover {
        border-radius: 2px;
        opacity: .8;
        background: rgba(203, 203, 203, 0.2);
      }
    }

    &_error {
      @include block;
      @include error;

      &__sub,
      &__plus {
        &:hover {
          @include error;
        }
      }
      input {
        @include error;
        background: transparent;
        &:hover {
          background: transparent;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/Components/InputAmount.vue